import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
import styles from './StaticData.module.scss';
import tabStyles from './TabOverride.module.scss';
import StaticDataIsda from './staticdataisda/StaticDataIsda';
import StaticDataMappings from './staticdatamappings/StaticDataMappings';
import StaticDataGeneral from './staticdatageneral/StaticDataGeneral';

export default (withRouter(() => (
    <div className={ styles.staticData }>
        <div className={ styles.header }>
            Static Data
        </div>
        <div className={ styles.tabContainer }>
            <Tab
                rememberLastTab
                styles={ tabStyles }
                tabs={ [
                    {
                        title: 'Static Data ISDA',
                        path: '/staticdataisda',
                        component: StaticDataIsda
                    },
                    {
                        title: 'Static Data Mappings',
                        path: '/staticdatamappings',
                        component: StaticDataMappings
                    },
                    {
                        title: 'Static Data General',
                        path: '/staticdatageneral',
                        component: StaticDataGeneral
                    }
                ] }
            />
        </div>
    </div>
)));
